import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
import { availabilityOptionLabels } from "../../../../backendApi/CollectionApi";
import { pushCollectionAction } from "../../CollectionUtils";
export const AvailabilityFilter = (param)=>{
    let { Status, activeStatus, updateStatus, visibleOptions } = param;
    const toRender = visibleOptions.map((option)=>Status.find((f)=>f.Id === option) ?? {
            Id: option,
            Name: option,
            Count: 0
        });
    const checkbox = OptionCheckbox({
        activeStatus,
        updateStatus
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "c-filter__group",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "c-filter__group-title",
                children: "Beschikbaarheid"
            }),
            toRender.map(checkbox)
        ]
    });
};
const OptionCheckbox = (param)=>{
    let { activeStatus, updateStatus } = param;
    return (param)=>{
        let { Id, Name, Count } = param;
        const push = pushCollectionAction();
        const checked = activeStatus.has(Id);
        const update = ()=>{
            push(`filter-Availability-${checked ? 'off' : 'on'}`, Name);
            updateStatus((checked ? activeStatus.delete(Id) : activeStatus.add(Id)).toArray());
        };
        const inputId = `Availability-input-${Id}`;
        const labelId = `Availability-label-${Id}`;
        return /*#__PURE__*/ _jsxs("div", {
            className: "c-filter__checkbox",
            children: [
                /*#__PURE__*/ _jsx("input", {
                    id: inputId,
                    type: "checkbox",
                    checked: checked,
                    name: Name,
                    value: Id,
                    onChange: update,
                    "aria-describedby": labelId
                }),
                /*#__PURE__*/ _jsxs("label", {
                    id: labelId,
                    className: "c-filter__checkbox-label",
                    htmlFor: inputId,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "checkbox-label__name",
                            children: availabilityOptionLabels[Id]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "checkbox-label__count",
                            children: Count
                        })
                    ]
                })
            ]
        }, `Availability__${Id}`);
    };
};
